export default __webpack_public_path__ + "static/media/portfolio.9d5d4a32.png";